export default __webpack_public_path__ + "static/media/STD1.ea89224b.png";